import TaiKhoanLaiXe from "./stores/TaiKhoanLaiXe";
import CongHoaDonDienTu from "./stores/CongHoaDonDienTu";
export default {
    modules: {
        TaiKhoanLaiXe: TaiKhoanLaiXe,
        CongHoaDonDienTu
    }
};
